var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDealflow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8062 22H2.80615C2.39615 22 2.05615 21.66 2.05615 21.25C2.05615 20.84 2.39615 20.5 2.80615 20.5H22.8062C23.2162 20.5 23.5562 20.84 23.5562 21.25C23.5562 21.66 23.2162 22 22.8062 22Z",
    fill: "#464650"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5562 4V22H15.0562V4C15.0562 2.9 14.6062 2 13.2562 2H12.3562C11.0062 2 10.5562 2.9 10.5562 4Z",
    fill: "#464650"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.80615 10V22H7.80615V10C7.80615 8.9 7.40615 8 6.20615 8H5.40615C4.20615 8 3.80615 8.9 3.80615 10Z",
    fill: "#464650"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8062 15V22H21.8062V15C21.8062 13.9 21.4062 13 20.2062 13H19.4062C18.2062 13 17.8062 13.9 17.8062 15Z",
    fill: "#464650"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDealflow);
export default __webpack_public_path__ + "static/media/dealflow.1eceed4653046667103c026ddd9af306.svg";
export { ForwardRef as ReactComponent };